"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertErrorToTapeFailureResult = exports.convertErrorToStructuredError = exports.convertErrorMessageToStructuredError = void 0;
const common_1 = require("@finley-technologies/common");
const convertErrorMessageToStructuredError = (errorMessage) => {
    return {
        message: errorMessage,
        type: 'structuredError',
        structuredError: {
            externalMessage: errorMessage,
        },
    };
};
exports.convertErrorMessageToStructuredError = convertErrorMessageToStructuredError;
const convertErrorToStructuredError = (error, prefix) => {
    // eslint-disable-next-line no-param-reassign
    prefix = prefix ?? '';
    const errorMessage = `${prefix}${common_1.error.getErrorMessage(error)}`;
    return (0, exports.convertErrorMessageToStructuredError)(errorMessage);
};
exports.convertErrorToStructuredError = convertErrorToStructuredError;
const convertErrorToTapeFailureResult = (error, prefix) => {
    return {
        isValid: false,
        errors: [(0, exports.convertErrorToStructuredError)(error, prefix)],
    };
};
exports.convertErrorToTapeFailureResult = convertErrorToTapeFailureResult;
//# sourceMappingURL=errorUtils.js.map